export default __webpack_public_path__ + "static/media/first-project.19c55a61.svg";